import React from 'react';
import {ReactComponent as CloudUpload} from  '../../../assets/icons/cloud-upload.svg';

const ArtworkUploadBox = ({ onUpload, disabled = false }) => {
    const handleClick = () => {
        if (!disabled && onUpload) {
            onUpload();
        }
    };

    return (
        <div 
            className={`artworkUploadBox ${disabled ? 'artworkUploadBoxDisabled' : ''}`}
            onClick={handleClick}
        >
            <CloudUpload />
            <span className="uploadText">Upload</span>
        </div>
    );
};

export default ArtworkUploadBox;
